export default class ReportLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_reportLayer';
   
    this.clearEvent();
    this.setEvent();
  }

  setEvent() {
    this.welContainer.on('change', 'input[name=radioReport]', e => {
      this.onChangeReportType(e);
    });
    this.welContainer.on('click', '#reportReview', e => {
      this.submitReport(e);
    });
  }

  clearEvent() {
    this.welContainer.off('change', 'input[name=radioReport]');
    this.welContainer.off('click', '#reportReview');
  }

  /**
   * 레이어 열기 함수
   */
  open = (sReviewSrl, openType) => {
    // 레이어 오픈 타입 저장
    this.openType = openType;
    this.render();
    $(`#${this.sWrapper}`)
      .find('[name=sReviewSrl]')
      .val(sReviewSrl);
    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: false,
        bUseHistorybackOnClose: false,
        bShowDimmed: false,
      });
    } else {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
    }
  };

  onChangeReportType(e) {
    this.welContainer.find('#_reportInputComment').hide();
    $(e.currentTarget)
      .closest('li')
      .find('#_reportInputComment')
      .show();
  }

  submitReport(e) {  
    const reportType = $('input[name=radioReport]:checked').val();
    const sReviewSrl = $('input[name=sReviewSrl]').val();
    if (!reportType) {
      alert('신고 사유를 선택해 주세요.');
      e.preventDefault();
      return;
    }
    const reportUrl = reportType === '4' ? $('#_reportInputComment').val() : '';
    if (this.openType === "qna") {
      TMON.oApp.oApi.fetchApi('qnaReport', {
        aSrl: sReviewSrl,
        reportType,
        reportUrl,
      });
    } else {
      TMON.oApp.oApi.fetchApi('reportReview', {
        sReviewSrl,
        reportType,
        reportUrl,
      });
    }

    if (TMON.oApp.sPlatform === 'PW') {
      this.welContainer.find('[data-role=close]').trigger('click');
    } else if(this.openType === "photoReview"){
        history.go(-2);
      } else {
        history.back();
      }
    e.preventDefault();
  }

  render = () => {
    $(`#${this.sWrapper}`).remove();
    const sHtml = `
            <section id="${this.sWrapper}" class="popup popup_layer popup_report">
                <header class="popup_header">
                    <h3 class="popup_header_title">신고하기</h3>
                    <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                        </svg>
                    </button>
                </header>
                <div class="popup_contents">
                    <article class="popup_inner">
                        <form action="">
                            <input type="hidden" name="sReviewSrl" value="">
                            <p class="popup_report_desc">
                                신고 사유를 선택해주세요.<br>
                                신고된 ${this.openType === "qna" ? '문의글' : '상품평'}은 즉시 차단되며, 신고 내용은 이용약관 및 정책에 의해 처리됩니다.
                            </p>
                            <ul class="popup_report_list">
                                <li>
                                    <div class="input_box input_radio">
                                        <input type="radio" title="선택하기" class="input_unit" name="radioReport" value="1" id="radiosReport1">
                                        <label for="radiosReport1" class="input_text">부적절한 홍보 또는 비방글</label>
                                    </div>
                                </li>
                                <li>
                                    <div class="input_box input_radio">
                                        <input type="radio" title="선택하기" class="input_unit" name="radioReport" value="2" id="radiosReport2">
                                        <label for="radiosReport2" class="input_text">욕설 또는 무의미한 단어의 반복</label>
                                    </div>
                                </li>
                                <li>
                                    <div class="input_box input_radio">
                                        <input type="radio" title="선택하기" class="input_unit" name="radioReport" value="3" id="radiosReport3">
                                        <label for="radiosReport3" class="input_text">음란성 또는 청소년에게 부적합한 내용</label>
                                    </div>
                                </li>
                                <li>
                                    <div class="input_box input_radio">
                                        <input type="radio" title="선택하기" class="input_unit" name="radioReport" value="4" id="radiosReport4">
                                        <label for="radiosReport4" class="input_text">명예훼손 및 저작권 침해 등</label>
                                    </div>
                                    <input id="_reportInputComment" type="text" title="저작권 원본의 주소를 입력해주세요" placeholder="저작권 원본의 주소를 입력해주세요." class="input_report_text" name="reportUrl" style="display:none">
                                </li>
                                <li>
                                    <div class="input_box input_radio">
                                        <input type="radio" title="선택하기" class="input_unit" name="radioReport" value="5" id="radiosReport5">
                                        <label for="radiosReport5" class="input_text">관련법 위반</label>
                                    </div>
                                </li>
                            </ul>
                        </form>
                    </article>
                    <!-- [D] 버튼 -->
                    <div class="popup_buttons">
                        <button id="reportReview" type="button" class="popup_button type01">
                        신고하기
                        </button>
                    </div>
                </div>
            </section>
        `;

    this.welContainer.append(sHtml);
  };
}